











































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import Event from '@/modules/reservation/model/Event'
import {Action, Mutation, State} from 'vuex-class'
import LoadingScreen from '@/modules/core/LoadingScreen'
import EventDetail from '@/modules/reservation/components/EventDetail.vue'
import {MutationTypes} from '@/modules/reservation/store/mutations'
import Loader from '@/components/Loader.vue';
import ConfirmEventDelete from '@/modules/reservation/components/ConfirmEventDelete.vue';

/**
 * Lista de eventos
 *
 * Muestra al usuario la lista de eventos de reservas registrados
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmEventDelete, Loader, EventDetail},
})
export default class EventList extends Vue {
    /**
     * Lista de eventos
     */
    @State(state => state.reservation.events)
    public events: Event[]

    @State(state => state.reservation.loadingEventList)
    public loadingEventList: boolean

    @Mutation(`reservation/${MutationTypes.SetCurrentEvent}`)
    public setCurrentEvent: (event: Event) => void

    @Action('reservation/loadEventList')
    public loadEventList: () => void

    /**
     * Controla la visibilidad del componente encargado de mostrar la información
     * del evento
     */
    public eventDetail = false
    public confirmDeleteEvent = false

    public loading = true

    /**
     * Cabeceras de la tabla
     */
    public headers = [
        {text: 'Id', value: 'id'},
        {text: 'Nombre', value: 'name'},
        {text: 'Acciones', value: 'id', sortable: false, align: 'right'},
    ]

    /**
     * Al crear el componente carga la lista de eventos
     */
    public async created() {
        await this.loadEventList()
        this.loading = false
    }

    /**
     * Procede a editar un evento
     *
     * @param event
     */
    public edit(event: Event) {
        this.setCurrentEvent(_.cloneDeep(event))
        this.eventDetail = true
    }

    /**
     * Abre el dialogo de confirmación para eliminar el event seleccionado
     * por el usuario
     *
     * @param event
     */
    public deleteEvent(event: Event) {
        this.setCurrentEvent(event)
        this.confirmDeleteEvent = true
    }

    public createNewEvent() {
        this.edit(new Event())
    }
}
